import { jsx as _jsx } from "@redneckz/uni-jsx/jsx-runtime";
import { ScrollableTabsControl } from '../../ui-kit/TabsControl/ScrollableTabsControl.js';
import { style } from '../../utils/style.js';
const tabsStyle = {
    default: {
        wrapper: '',
        component: '',
    },
    animated: {
        wrapper: 'border-b-8 border-primary-main bg-white',
        component: 'm-auto',
    },
    underlined: {
        wrapper: 'flex',
        component: 'm-auto',
    },
};
export const renderTabsLayout = ({ className = '', tabsType = 'animated', ...props }) => tabsType ? (_jsx("div", { className: style(tabsStyle[tabsType].wrapper, className), children: _jsx(ScrollableTabsControl, { className: tabsStyle[tabsType].component, tabsType: tabsType, ...props }) })) : null;
//# sourceMappingURL=renderTabsLayout.js.map